/**
 * @fileoverview Async appending of Styleguide Icons to Document.
 * @copyright Sisense Inc.
 * @licence Sisense License.
 */

// eslint-disable-next-line import/no-webpack-loader-syntax
import iconsSvg from '!!raw-loader!./sprites/icons.svg';

const { document } = window;
const container = document.createElement('div');
container.style.display = 'none';

container.innerHTML = iconsSvg;

setTimeout(() => {
    document.body.appendChild(container);
}, 0);
